module.exports = __webpack_public_path__ + "img/bus-marker-logo.f96bb2b1.svg";